import GoogleButton from 'components/common/Buttons/GoogleButton';
import Button from 'components/common/Buttons/index';
import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import { scrollToSection } from 'helpers';
import { useAnimationWithWithoutScroll } from 'hooks/useAnimation';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentLocationIsLoading, selectLocationsPageTags } from 'store/slices/LocationsSlice';

const HeroComponent = ({ title, desc, button_text, button_text_link, hasCrumbs }) => {
    const handleScroll = () => {
        scrollToSection('locations')
    }
    const container = useRef();

    const isLoading = useSelector(selectCurrentLocationIsLoading)
    const locationsTags = useSelector(selectLocationsPageTags)

    useAnimationWithWithoutScroll({
        item: '.hero-body',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })
    useAnimationWithWithoutScroll({
        item: '.hero-body-buttons',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })

    return (
        <div ref={container} className={`hero-container ${hasCrumbs ? "hero-container--with-crumbs" : ""}`}>
            {hasCrumbs && <HeroCrumbs page={"Proxy Locations"} />}
            <div className='hero-body'>
                <h1 className='hero-body__title'>{title}</h1>
                <div className='body1 hero-body__desc'>{desc}</div>
            </div>
            <div className='hero-body-buttons'>
                <Button text={button_text} type='outlineAnchor' onClick={handleScroll} />
                {
                    locationsTags.start_with_google_button && <GoogleButton />
                }

            </div>
        </div>
    );
}

export default HeroComponent;